import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4ba6c0bc&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=4ba6c0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6c0bc",
  null
  
)

export default component.exports